import styled from '@emotion/styled';
import { TextStyle } from 'styles/variables/mixins';
import { Colors } from 'styles/variables/colors';
import { NavLink } from 'react-router-dom';
import { ListItemButton } from '@mui/material';
import { Breakpoints } from 'styles/variables/breakpoints';

const { blue, white, switcherTextColor } = Colors;
const { lg, xl } = Breakpoints;

export const Title = styled.h1`
    margin-right: 1rem;
    display: flex;
    gap: 0.8rem;
    width: 100%;
`;

export const SwitcherText = styled.p`
    ${TextStyle({ fontSize: '14px', fontWeight: '400', color: switcherTextColor })}
`;

//card

export const Container = styled.div`
    /* max-width: 852px; */
    margin-top: 43px;
    // border: 1px solid ${Colors.inputBorder};
    border: 1px solid #f3f4f6ff;
    box-shadow: 0px 10px 20px -15px #171a1f;
    /* box-shadow: 0px 4px 9px #171a1f, 0px 0px 2px #171a1f; */
    background: white; /* white */
    border-radius: 4px; /* border-m */
`;
export const FormContainer = styled.div`
    /* max-width: 852px; */
    margin-top: 43px;
    border: 1px solid #f3f4f6ff;
    box-shadow: 0px 10px 20px -15px #171a1f;
    /* box-shadow: 0px 0px 1px #171a1f, 0px 0px 2px #171a1f; */
    background: white; /* white */
    border-radius: 3px; /* border-m */
`;

export const Body = styled.div`
    padding: 30px 15px 16px;
`;
export const Box = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    row-gap: 24px;
    column-gap: 10%;
    padding-bottom: 18px;
`;

export const BoxItem = styled.span`
    width: 45%;
`;

export const TopPartBoxItemCentered = styled.span`
    width: 22%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

// btns
export const Buttons = styled.button`
    margin-top: 25px;
    margin-left: auto;
    display: flex;
    gap: 22px;
`;
export const SaveButton = styled.button`
    height: 36px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${TextStyle({ fontSize: '14px', fontWeight: '400', color: '#8353E2FF' })}
    background: white; /* white */
    opacity: 1;
    border: 1px solid #8353e2ff; /* border-s */
    border-radius: 3px;
`;

export const GroupButtons = styled.div`
    display: flex;
    gap: 12px;
    padding: 24px 0 0 0;
    justify-content: flex-end;
    margin-top: 32px;
    border-top: 1px solid #e0e0e0;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
`;

interface SaveButtonProps {
    disabled?: boolean;
    variant?: 'outlined' | 'contained';
}

export const SaveChangesButton = styled.button<SaveButtonProps>`
    height: 44px;
    min-width: 140px;
    padding: 0 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    font-size: 15px;
    font-weight: 500;
    transition: all 0.2s ease;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

    ${({ variant = 'outlined', disabled }) =>
        variant === 'contained'
            ? `
        /* Primary/Contained button */
        background: #8353E2;
        color: white;
        border: none;
        
        &:hover {
            background: ${disabled ? '#8353E2' : '#6025D8'};
            box-shadow: ${disabled ? '0 1px 3px rgba(0, 0, 0, 0.1)' : '0 2px 8px rgba(131, 83, 226, 0.3)'};
            transform: ${disabled ? 'none' : 'translateY(-1px)'};
        }
        
        &:active {
            background: #4A1B9E;
            transform: translateY(0);
        }
    `
            : `
        /* Secondary/Outlined button */
        background: white;
        color: #8353E2;
        border: 1.5px solid #8353E2;
        
        &:hover {
            background: ${disabled ? 'white' : '#F8F5FF'};
            border-color: ${disabled ? '#8353E2' : '#6025D8'};
            box-shadow: ${disabled ? '0 1px 3px rgba(0, 0, 0, 0.1)' : '0 2px 6px rgba(131, 83, 226, 0.15)'};
            transform: ${disabled ? 'none' : 'translateY(-1px)'};
        }
        
        &:active {
            background: #E8DEFF;
            transform: translateY(0);
        }
    `}

    opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`;

export const NextButton = styled.button`
    height: 36px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${TextStyle({ fontSize: '14px', fontWeight: '400', color: white })}
    background-color: #6025D8FF; /* secondary-500 */
    opacity: 1;
    border: none;
    border-radius: 3px; /* border-s */
`;

//right part container
export const OnboardingContainer = styled.div`
    margin-top: 11px;
    width: 100%;
    height: 322px;
    background: white; /* white */
    border-radius: 4px; /* border-m */
    border-width: 1px solid #f3f4f6ff;
    box-shadow: 0px 10px 20px -15px #171a1f;
    border: 1px solid #f3f4f6ff;
    /* box-shadow: 0px 8px 17px #171a1f, 0px 0px 2px #171a1f; shadow-l */
    padding: 22px;
`;

export const OnboardingTitle = styled.h3`
    ${TextStyle({ fontSize: '18px', fontWeight: '700', color: '#171A1FFF5' })};
    margin-bottom: 33px;
`;

export const selectClientTitle = styled.h3`
    ${TextStyle({ fontSize: '18px', fontWeight: '700', color: '#171A1FFF5' })};
    margin-bottom: 14px;
`;

export const OnboardingContent = styled.div`
    display: flex;
    gap: 22px;
`;
export const OnboardingRoundWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 190px;
    justify-content: space-between;
`;
export const OnboardingRoundContainers = styled.div`
    width: 48px;
    height: 48px;
    background: #171a1fff; /* neutral-900 */
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const OnboardingButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 37px;
`;
export const StyledActiveLink = styled(NavLink)`
    height: 36px;
    width: 212px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${TextStyle({ fontSize: '15px', fontWeight: '400', color: '#8353E2FF' })}
    background: white; /* white */
    opacity: 1;
    border: 1px solid #8353e2ff; /* border-s */
    border-radius: 3px;

    &.active {
        color: #ffffffff; /* white */
        background: #6025d8ff; /* secondary-600 */
    }
    &:hover {
        color: #ffffffff; /* white */
        background: #6025d8ff; /* secondary-600 */
    }
`;

export const OnboardingButton = styled.button`
    height: 36px;
    width: 212px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${TextStyle({ fontSize: '14px', fontWeight: '400', color: '#8353E2FF' })}
    background: white; /* white */
    opacity: 1;
    border: 1px solid #8353e2ff; /* border-s */
    border-radius: 3px;
`;
export const OnboardingLine = styled.span`
    display: unset;
    width: 25px;
    height: 0;
    border: 1px solid #1d2128ff;
    transform: rotate(90deg);
`;

////////////new

const { formBackground, darkGray, purple, darkBlack } = Colors;

export const BoxX = styled.div`
    width: 100%;
    padding: 38px;
    padding-top: 28px;
    padding-bottom: 22px;
    background-color: ${formBackground};
    margin-bottom: 25px;
    /* is this in all */
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 1.25rem;
    @media screen and (min-width: ${xl}) {
        min-width: 430px;
        width: 100%;
    }
`;

export const BoxPart1 = styled.div`
    width: 100%;
    padding: 38px;
    padding-top: 28px;
    padding-bottom: 22px;
    background-color: ${formBackground};
    margin-bottom: 25px;
    @media screen and (min-width: ${xl}) {
        min-width: 430px;
        width: 100%;
    }
`;

export const BoxPart2 = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 1.25rem;
`;

export const ContainerX = styled.div`
    display: flex;
    gap: 64px;
    margin-top: 34px;
    @media screen and (max-width: ${lg}) {
        flex-direction: column;
        gap: 40px;
    }
`;

export const HideLg = styled.span`
    @media screen and (min-width: 1025px) {
        display: none;
    }
`;

export const HideXs = styled.span`
    @media screen and (max-width: ${lg}) {
        display: none;
    }
`;

export const Main = styled.span`
    @media screen and (min-width: 1025px) {
        width: 100%;
    }
`;

export const MenuItem = styled(ListItemButton)`
    display: flex;
    align-items: center;
`;

export const NavLinkCo = styled(NavLink)`
    ${TextStyle({ fontSize: '15px', fontWeight: '500' })};
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    text-transform: capitalize;
    fill: ${darkGray};
    min-height: 30px;
    box-sizing: border-box;
    cursor: pointer;

    &.active {
        fill: ${blue};
        color: ${blue};
        opacity: 1 !important;
    }
`;

export const NavLinkSpan = styled.div`
    display: flex;
`;

export const SbItem = styled.div`
    display: flex;
    align-items: center;
`;

export const SbItemContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 270px;
    width: 100%;
    height: 64px;
    padding: 0px 32px;
    gap: 10px;
    background: ${white};
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
    border-radius: 4px;
    margin-bottom: 10px;
    color: ${darkBlack};
    height: 56px;
    width: 270px;
    &:active {
        background: ${white};
        color: ${purple};
    }
    @media screen and (max-width: 1024px) {
        min-width: 250px;
        max-width: 270px;
        justify-content: center;
        background: ${white};
        overflow: visible;
    }
    @media screen and (min-width: 1025px) {
        min-width: 305px;
    }
    @media screen and (max-width: ${lg}) {
        height: 64px;
    }
    @media screen and (min-width: 1025px) {
        min-width: 305px;
    }
`;

export const SideBar = styled.span`
    @media screen and (min-width: 1025px) {
        width: 270px;
    }
`;

export const Text = styled.p`
    ${TextStyle({ fontSize: '15px', fontWeight: '600' })};
    color: inherit;
`;

export const TitleX = styled.h4`
    margin-bottom: 16px;
`;

export const Value = styled.p`
    ${TextStyle({ fontSize: '15px', fontWeight: '400' })};
    margin-bottom: 18px;
`;

export const SignedRetainerAgreementTemplateFooter = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`;

export const NewRetainerAgreementTemplateFooter = styled.div<{
    mobile?: boolean;
    customStyle?: boolean;
}>`
    align-items: ${({ customStyle }) => (customStyle ? 'flex-end' : 'center')};
    display: flex;
    flex-direction: ${({ customStyle }) => (customStyle ? 'column-reverse' : 'row')};
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    gap: 5px;
    margin-top: 16px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
`;

export const TopWrapper = styled.section`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 36px;
    margin-top: 40px;
`;

export const OpenCaseTitle = styled.h1`
    ${TextStyle({ fontSize: '25px', fontWeight: '700' })};
`;

export const ModalWrapper = styled.div<{ fullscreen?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${({ fullscreen }) => (fullscreen ? '100vh' : 'auto')};
    padding: ${({ fullscreen }) => (fullscreen ? '0' : '2rem')};
    background: transparent;
`;

export const ModalContent = styled.div<{ fullscreen?: boolean }>`
    background: ${white};
    border-radius: 8px;
    box-shadow: 0px 10px 20px -15px #171a1f;
    padding: 2rem;
    max-width: 500px;
    width: 100%;
    height: ${({ fullscreen }) => (fullscreen ? '90%' : 'auto')};
    overflow-y: ${({ fullscreen }) => (fullscreen ? 'auto' : 'initial')};
`;

export const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
`;

export const ModalTitle = styled.h2`
    ${TextStyle({ fontSize: '20px', fontWeight: '700', color: '#171a1f' })};
    margin: 0;
`;

export const ModalCloseButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
`;

export const ModalButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 2rem;
`;

export const ModalButton = styled.button<{ background?: string }>`
    background: ${({ background }) => background || '#8353E2'};
    border: none;
    border-radius: 4px;
    padding: 0.75rem 1.5rem;
    cursor: pointer;
    ${TextStyle({ fontSize: '14px', fontWeight: '600', color: 'white' })};
    min-width: 5rem;
`;
